export namespace Constants {
  export const DB_SERVER = 'https://api.bgcourts.eu';
  export const REG_SERVER = 'https://api.bgcourts.eu';
//  export const REG_SERVER = 'http://localhost:6000';

}

